// extracted by mini-css-extract-plugin
export default {"zipPay":"ZipPay_zipPay__ufbCA","link":"ZipPay_link__Xsdr6"};